import React, { createContext, FC, ReactNode, useContext } from 'react';

import { useIubendaConsent } from '~/hooks/useIubendaConsent';
import { ConsentStatus } from '~/hooks/iubendaConsent';

export type { ConsentStatus };

interface CookieConsentContextValue {
  consentStatus: ConsentStatus;
}

const CookieConsentContext = createContext<CookieConsentContextValue>({
  consentStatus: 'pending',
});

export const CookieConsentProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const consentStatus = useIubendaConsent();

  return (
    <CookieConsentContext.Provider value={{ consentStatus }}>
      {children}
    </CookieConsentContext.Provider>
  );
};

export const useCookieConsent = (): CookieConsentContextValue =>
  useContext(CookieConsentContext);
